import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AddInviteeResponse = {
  __typename?: 'AddInviteeResponse';
  invitees?: Maybe<Array<Invitee>>;
  isSuccess: Scalars['Boolean'];
};

export type CreateTeamInput = {
  name: Scalars['String'];
};

export type CreateTeamResponse = {
  __typename?: 'CreateTeamResponse';
  id: Scalars['String'];
  isSuccess: Scalars['Boolean'];
  name: Scalars['String'];
};

export enum FeatureType {
  Login = 'LOGIN',
  Signup = 'SIGNUP'
}

export type Flags = {
  __typename?: 'Flags';
  flag: Scalars['String'];
  key: UserStateFlags;
  value: Scalars['Boolean'];
};

export type GetColleaguesResponse = {
  __typename?: 'GetColleaguesResponse';
  colleagues?: Maybe<Array<User>>;
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  productName: Scalars['String'];
  userId: Scalars['String'];
};

export type GetHelpInput = {
  comments: Scalars['String'];
  featureId: Scalars['String'];
  featureType: FeatureType;
  featureTypeId: Scalars['String'];
  subFeatureId?: InputMaybe<Scalars['String']>;
  taskName: Scalars['String'];
  teamIds?: InputMaybe<Array<Scalars['String']>>;
  users: Array<InviteeInput>;
};

export type GetHelpInputV2 = {
  comments: Scalars['String'];
  featureId: Scalars['String'];
  featureTypeId: Scalars['String'];
  inviteUrl: Scalars['String'];
  taskName: Scalars['String'];
  teamIds?: InputMaybe<Array<Scalars['String']>>;
  users: Array<InviteeInput>;
  varibles: Scalars['String'];
};

export type GetHelpResponse = {
  __typename?: 'GetHelpResponse';
  isSuccess: Scalars['Boolean'];
};

export type GetInviteesResponse = {
  __typename?: 'GetInviteesResponse';
  invitees?: Maybe<Array<Invitee>>;
  taskId: Scalars['String'];
};

export type GetProductsForUserIdResponse = {
  __typename?: 'GetProductsForUserIdResponse';
  products: Array<ProductDetails>;
  userId: Scalars['String'];
};

export type GetRolesResponse = {
  __typename?: 'GetRolesResponse';
  roles?: Maybe<Array<Role>>;
};

export type GetTeamUsersInput = {
  productId: Scalars['String'];
};

export type GetTeamUsersResponse = {
  __typename?: 'GetTeamUsersResponse';
  teams?: Maybe<Array<TeamUserData>>;
};

export type GetTeamsResponse = {
  __typename?: 'GetTeamsResponse';
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  teams?: Maybe<Array<Team>>;
};

export type GetUserStateResponse = {
  __typename?: 'GetUserStateResponse';
  email: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  productName: Scalars['String'];
  stateFlags?: Maybe<Array<Flags>>;
  userId: Scalars['String'];
};

export type Invitee = {
  __typename?: 'Invitee';
  emailId: Scalars['String'];
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  role: Role;
  taskRole?: Maybe<TaskInviteeRole>;
  team: Team;
};

export type InviteeInput = {
  emailId: Scalars['String'];
  roleId: Scalars['String'];
  teamId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type InviteeSignUpTrackEventInput = {
  inviteURL: Scalars['String'];
  userId: Scalars['String'];
};

export type InviteeSignUpTrackEventResponse = {
  __typename?: 'InviteeSignUpTrackEventResponse';
  success: Scalars['Boolean'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addInvitee: AddInviteeResponse;
  createTeam: CreateTeamResponse;
  getHelp: GetHelpResponse;
  getHelpv2: GetHelpResponse;
};


export type MutationAddInviteeArgs = {
  invitees: Array<InviteeInput>;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationGetHelpArgs = {
  input: GetHelpInput;
};


export type MutationGetHelpv2Args = {
  input: GetHelpInputV2;
};

export type OrganizationUsers = {
  __typename?: 'OrganizationUsers';
  emailId: Scalars['String'];
  id: Scalars['String'];
  organizationId: Scalars['String'];
  stateManagementFlags?: Maybe<Array<Flags>>;
};

export type ProductDetails = {
  __typename?: 'ProductDetails';
  accountId: Scalars['String'];
  accountName: Scalars['String'];
  orgId: Scalars['String'];
  orgName: Scalars['String'];
  productId: Scalars['String'];
  productName: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  getColleagues: GetColleaguesResponse;
  getInvitees: GetInviteesResponse;
  getProductsForUserId: GetProductsForUserIdResponse;
  getRoles: GetRolesResponse;
  getTeamUsers: GetTeamUsersResponse;
  getTeams: GetTeamsResponse;
  getUser: GetUserStateResponse;
  getUserByEmail: GetUserStateResponse;
  protected: Scalars['String'];
  searchOrganizationUsers: SearchOrganizationUsersResponse;
  sendInviteeSignUpTrackEvent: InviteeSignUpTrackEventResponse;
};


export type QueryGetColleaguesArgs = {
  userId: Scalars['String'];
};


export type QueryGetInviteesArgs = {
  taskId?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductsForUserIdArgs = {
  userId: Scalars['String'];
};


export type QueryGetTeamUsersArgs = {
  input: GetTeamUsersInput;
};


export type QueryGetUserArgs = {
  userId: Scalars['String'];
};


export type QueryGetUserByEmailArgs = {
  emailId: Scalars['String'];
};


export type QuerySearchOrganizationUsersArgs = {
  input?: InputMaybe<SearchOrganizationUsersInput>;
};


export type QuerySendInviteeSignUpTrackEventArgs = {
  input: InviteeSignUpTrackEventInput;
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SearchOrganizationUsersInput = {
  emailKey?: InputMaybe<Scalars['String']>;
  pageNo?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type SearchOrganizationUsersResponse = {
  __typename?: 'SearchOrganizationUsersResponse';
  users?: Maybe<Array<OrganizationUsers>>;
};

export enum TaskInviteeRole {
  TaskInviteeRoleAssignee = 'TASK_INVITEE_ROLE_ASSIGNEE',
  TaskInviteeRoleWatcher = 'TASK_INVITEE_ROLE_WATCHER'
}

export type Team = {
  __typename?: 'Team';
  id: Scalars['String'];
  name: Scalars['String'];
  userCount?: Maybe<Scalars['Int']>;
};

export type TeamUserData = {
  __typename?: 'TeamUserData';
  teamId: Scalars['String'];
  teamName: Scalars['String'];
  users?: Maybe<Array<User>>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  isActivated: Scalars['Boolean'];
  name: Scalars['String'];
  userId: Scalars['String'];
};

export enum UserStateFlags {
  DebuggerWalkthrough = 'DEBUGGER_WALKTHROUGH',
  FeatureFlowModal = 'FEATURE_FLOW_MODAL',
  InviteFlowGratification = 'INVITE_FLOW_GRATIFICATION',
  IsActivated = 'IS_ACTIVATED',
  IsInvited = 'IS_INVITED',
  TaskWalkthrough = 'TASK_WALKTHROUGH',
  Unspecified = 'UNSPECIFIED'
}

export type GetTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeamsQuery = { __typename?: 'Query', getTeams: { __typename?: 'GetTeamsResponse', productId: string, organizationId: string, teams?: Array<{ __typename?: 'Team', id: string, name: string, userCount?: number | null }> | null } };

export type GetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { __typename?: 'Query', getRoles: { __typename?: 'GetRolesResponse', roles?: Array<{ __typename?: 'Role', id: string, name: string }> | null } };

export type GetInviteesQueryVariables = Exact<{
  taskId?: InputMaybe<Scalars['String']>;
}>;


export type GetInviteesQuery = { __typename?: 'Query', getInvitees: { __typename?: 'GetInviteesResponse', taskId: string, invitees?: Array<{ __typename?: 'Invitee', id: string, emailId: string, taskRole?: TaskInviteeRole | null, isActivated?: boolean | null, name?: string | null, image?: string | null, role: { __typename?: 'Role', id: string, name: string }, team: { __typename?: 'Team', id: string, name: string, userCount?: number | null } }> | null } };

export type SearchOrganizationUsersQueryVariables = Exact<{
  input?: InputMaybe<SearchOrganizationUsersInput>;
}>;


export type SearchOrganizationUsersQuery = { __typename?: 'Query', searchOrganizationUsers: { __typename?: 'SearchOrganizationUsersResponse', users?: Array<{ __typename?: 'OrganizationUsers', id: string, emailId: string, organizationId: string, stateManagementFlags?: Array<{ __typename?: 'Flags', flag: string, value: boolean }> | null }> | null } };

export type AddInviteeMutationVariables = Exact<{
  input: Array<InviteeInput> | InviteeInput;
}>;


export type AddInviteeMutation = { __typename?: 'Mutation', addInvitee: { __typename?: 'AddInviteeResponse', isSuccess: boolean, invitees?: Array<{ __typename?: 'Invitee', id: string, emailId: string, taskRole?: TaskInviteeRole | null, team: { __typename?: 'Team', id: string, name: string, userCount?: number | null }, role: { __typename?: 'Role', id: string, name: string } }> | null } };

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'CreateTeamResponse', isSuccess: boolean, id: string, name: string } };

export type GetHelpMutationVariables = Exact<{
  input: GetHelpInput;
}>;


export type GetHelpMutation = { __typename?: 'Mutation', getHelp: { __typename?: 'GetHelpResponse', isSuccess: boolean } };

export type GetHelpv2MutationVariables = Exact<{
  input: GetHelpInputV2;
}>;


export type GetHelpv2Mutation = { __typename?: 'Mutation', getHelpv2: { __typename?: 'GetHelpResponse', isSuccess: boolean } };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'GetUserStateResponse', userId: string, name: string, email: string, image?: string | null, stateFlags?: Array<{ __typename?: 'Flags', key: UserStateFlags, value: boolean }> | null } };

export type GetColleaguesQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetColleaguesQuery = { __typename?: 'Query', getColleagues: { __typename?: 'GetColleaguesResponse', userId: string, organizationId: string, productId: string, productName: string, colleagues?: Array<{ __typename?: 'User', userId: string, name: string, email: string, isActivated: boolean }> | null } };

export type GetProductsForUserIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetProductsForUserIdQuery = { __typename?: 'Query', getProductsForUserId: { __typename?: 'GetProductsForUserIdResponse', userId: string, products: Array<{ __typename?: 'ProductDetails', productId: string, productName: string, orgId: string, orgName: string, accountId: string, accountName: string }> } };

export type GetUserByEmailQueryVariables = Exact<{
  emailId: Scalars['String'];
}>;


export type GetUserByEmailQuery = { __typename?: 'Query', getUserByEmail: { __typename?: 'GetUserStateResponse', userId: string, name: string, email: string, image?: string | null, stateFlags?: Array<{ __typename?: 'Flags', key: UserStateFlags, value: boolean }> | null } };

export type SendInviteeSignUpTrackEventQueryVariables = Exact<{
  input: InviteeSignUpTrackEventInput;
}>;


export type SendInviteeSignUpTrackEventQuery = { __typename?: 'Query', sendInviteeSignUpTrackEvent: { __typename?: 'InviteeSignUpTrackEventResponse', success: boolean } };

export type GetTeamUsersQueryVariables = Exact<{
  input: GetTeamUsersInput;
}>;


export type GetTeamUsersQuery = { __typename?: 'Query', getTeamUsers: { __typename?: 'GetTeamUsersResponse', teams?: Array<{ __typename?: 'TeamUserData', teamId: string, teamName: string, users?: Array<{ __typename?: 'User', userId: string, name: string, email: string, isActivated: boolean, image?: string | null }> | null }> | null } };


export const GetTeamsDocument = gql`
    query GetTeams {
  getTeams {
    productId
    organizationId
    teams {
      id
      name
      userCount
    }
  }
}
    `;

/**
 * __useGetTeamsQuery__
 *
 * To run a query within a React component, call `useGetTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeamsQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options);
      }
export function useGetTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options);
        }
export type GetTeamsQueryHookResult = ReturnType<typeof useGetTeamsQuery>;
export type GetTeamsLazyQueryHookResult = ReturnType<typeof useGetTeamsLazyQuery>;
export type GetTeamsQueryResult = Apollo.QueryResult<GetTeamsQuery, GetTeamsQueryVariables>;
export const GetRolesDocument = gql`
    query GetRoles {
  getRoles {
    roles {
      id
      name
    }
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetInviteesDocument = gql`
    query GetInvitees($taskId: String) {
  getInvitees(taskId: $taskId) {
    taskId
    invitees {
      id
      emailId
      role {
        id
        name
      }
      team {
        id
        name
        userCount
      }
      taskRole
      isActivated
      name
      image
    }
  }
}
    `;

/**
 * __useGetInviteesQuery__
 *
 * To run a query within a React component, call `useGetInviteesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInviteesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInviteesQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetInviteesQuery(baseOptions?: Apollo.QueryHookOptions<GetInviteesQuery, GetInviteesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInviteesQuery, GetInviteesQueryVariables>(GetInviteesDocument, options);
      }
export function useGetInviteesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInviteesQuery, GetInviteesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInviteesQuery, GetInviteesQueryVariables>(GetInviteesDocument, options);
        }
export type GetInviteesQueryHookResult = ReturnType<typeof useGetInviteesQuery>;
export type GetInviteesLazyQueryHookResult = ReturnType<typeof useGetInviteesLazyQuery>;
export type GetInviteesQueryResult = Apollo.QueryResult<GetInviteesQuery, GetInviteesQueryVariables>;
export const SearchOrganizationUsersDocument = gql`
    query SearchOrganizationUsers($input: SearchOrganizationUsersInput) {
  searchOrganizationUsers(input: $input) {
    users {
      id
      emailId
      organizationId
      stateManagementFlags {
        flag
        value
      }
    }
  }
}
    `;

/**
 * __useSearchOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useSearchOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOrganizationUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchOrganizationUsersQuery(baseOptions?: Apollo.QueryHookOptions<SearchOrganizationUsersQuery, SearchOrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOrganizationUsersQuery, SearchOrganizationUsersQueryVariables>(SearchOrganizationUsersDocument, options);
      }
export function useSearchOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOrganizationUsersQuery, SearchOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOrganizationUsersQuery, SearchOrganizationUsersQueryVariables>(SearchOrganizationUsersDocument, options);
        }
export type SearchOrganizationUsersQueryHookResult = ReturnType<typeof useSearchOrganizationUsersQuery>;
export type SearchOrganizationUsersLazyQueryHookResult = ReturnType<typeof useSearchOrganizationUsersLazyQuery>;
export type SearchOrganizationUsersQueryResult = Apollo.QueryResult<SearchOrganizationUsersQuery, SearchOrganizationUsersQueryVariables>;
export const AddInviteeDocument = gql`
    mutation AddInvitee($input: [InviteeInput!]!) {
  addInvitee(invitees: $input) {
    isSuccess
    invitees {
      id
      emailId
      team {
        id
        name
        userCount
      }
      role {
        id
        name
      }
      taskRole
    }
  }
}
    `;
export type AddInviteeMutationFn = Apollo.MutationFunction<AddInviteeMutation, AddInviteeMutationVariables>;

/**
 * __useAddInviteeMutation__
 *
 * To run a mutation, you first call `useAddInviteeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInviteeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInviteeMutation, { data, loading, error }] = useAddInviteeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddInviteeMutation(baseOptions?: Apollo.MutationHookOptions<AddInviteeMutation, AddInviteeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInviteeMutation, AddInviteeMutationVariables>(AddInviteeDocument, options);
      }
export type AddInviteeMutationHookResult = ReturnType<typeof useAddInviteeMutation>;
export type AddInviteeMutationResult = Apollo.MutationResult<AddInviteeMutation>;
export type AddInviteeMutationOptions = Apollo.BaseMutationOptions<AddInviteeMutation, AddInviteeMutationVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    isSuccess
    id
    name
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const GetHelpDocument = gql`
    mutation GetHelp($input: GetHelpInput!) {
  getHelp(input: $input) {
    isSuccess
  }
}
    `;
export type GetHelpMutationFn = Apollo.MutationFunction<GetHelpMutation, GetHelpMutationVariables>;

/**
 * __useGetHelpMutation__
 *
 * To run a mutation, you first call `useGetHelpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetHelpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getHelpMutation, { data, loading, error }] = useGetHelpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetHelpMutation(baseOptions?: Apollo.MutationHookOptions<GetHelpMutation, GetHelpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetHelpMutation, GetHelpMutationVariables>(GetHelpDocument, options);
      }
export type GetHelpMutationHookResult = ReturnType<typeof useGetHelpMutation>;
export type GetHelpMutationResult = Apollo.MutationResult<GetHelpMutation>;
export type GetHelpMutationOptions = Apollo.BaseMutationOptions<GetHelpMutation, GetHelpMutationVariables>;
export const GetHelpv2Document = gql`
    mutation GetHelpv2($input: GetHelpInputV2!) {
  getHelpv2(input: $input) {
    isSuccess
  }
}
    `;
export type GetHelpv2MutationFn = Apollo.MutationFunction<GetHelpv2Mutation, GetHelpv2MutationVariables>;

/**
 * __useGetHelpv2Mutation__
 *
 * To run a mutation, you first call `useGetHelpv2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetHelpv2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getHelpv2Mutation, { data, loading, error }] = useGetHelpv2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetHelpv2Mutation(baseOptions?: Apollo.MutationHookOptions<GetHelpv2Mutation, GetHelpv2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetHelpv2Mutation, GetHelpv2MutationVariables>(GetHelpv2Document, options);
      }
export type GetHelpv2MutationHookResult = ReturnType<typeof useGetHelpv2Mutation>;
export type GetHelpv2MutationResult = Apollo.MutationResult<GetHelpv2Mutation>;
export type GetHelpv2MutationOptions = Apollo.BaseMutationOptions<GetHelpv2Mutation, GetHelpv2MutationVariables>;
export const GetUserDocument = gql`
    query GetUser($userId: String!) {
  getUser(userId: $userId) {
    userId
    name
    email
    image
    stateFlags {
      key
      value
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetColleaguesDocument = gql`
    query GetColleagues($userId: String!) {
  getColleagues(userId: $userId) {
    userId
    organizationId
    productId
    productName
    colleagues {
      userId
      name
      email
      isActivated
    }
  }
}
    `;

/**
 * __useGetColleaguesQuery__
 *
 * To run a query within a React component, call `useGetColleaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColleaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColleaguesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetColleaguesQuery(baseOptions: Apollo.QueryHookOptions<GetColleaguesQuery, GetColleaguesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetColleaguesQuery, GetColleaguesQueryVariables>(GetColleaguesDocument, options);
      }
export function useGetColleaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetColleaguesQuery, GetColleaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetColleaguesQuery, GetColleaguesQueryVariables>(GetColleaguesDocument, options);
        }
export type GetColleaguesQueryHookResult = ReturnType<typeof useGetColleaguesQuery>;
export type GetColleaguesLazyQueryHookResult = ReturnType<typeof useGetColleaguesLazyQuery>;
export type GetColleaguesQueryResult = Apollo.QueryResult<GetColleaguesQuery, GetColleaguesQueryVariables>;
export const GetProductsForUserIdDocument = gql`
    query GetProductsForUserId($userId: String!) {
  getProductsForUserId(userId: $userId) {
    userId
    products {
      productId
      productName
      orgId
      orgName
      accountId
      accountName
    }
  }
}
    `;

/**
 * __useGetProductsForUserIdQuery__
 *
 * To run a query within a React component, call `useGetProductsForUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsForUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsForUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetProductsForUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetProductsForUserIdQuery, GetProductsForUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsForUserIdQuery, GetProductsForUserIdQueryVariables>(GetProductsForUserIdDocument, options);
      }
export function useGetProductsForUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsForUserIdQuery, GetProductsForUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsForUserIdQuery, GetProductsForUserIdQueryVariables>(GetProductsForUserIdDocument, options);
        }
export type GetProductsForUserIdQueryHookResult = ReturnType<typeof useGetProductsForUserIdQuery>;
export type GetProductsForUserIdLazyQueryHookResult = ReturnType<typeof useGetProductsForUserIdLazyQuery>;
export type GetProductsForUserIdQueryResult = Apollo.QueryResult<GetProductsForUserIdQuery, GetProductsForUserIdQueryVariables>;
export const GetUserByEmailDocument = gql`
    query GetUserByEmail($emailId: String!) {
  getUserByEmail(emailId: $emailId) {
    userId
    name
    email
    image
    stateFlags {
      key
      value
    }
  }
}
    `;

/**
 * __useGetUserByEmailQuery__
 *
 * To run a query within a React component, call `useGetUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByEmailQuery({
 *   variables: {
 *      emailId: // value for 'emailId'
 *   },
 * });
 */
export function useGetUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
      }
export function useGetUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
        }
export type GetUserByEmailQueryHookResult = ReturnType<typeof useGetUserByEmailQuery>;
export type GetUserByEmailLazyQueryHookResult = ReturnType<typeof useGetUserByEmailLazyQuery>;
export type GetUserByEmailQueryResult = Apollo.QueryResult<GetUserByEmailQuery, GetUserByEmailQueryVariables>;
export const SendInviteeSignUpTrackEventDocument = gql`
    query SendInviteeSignUpTrackEvent($input: InviteeSignUpTrackEventInput!) {
  sendInviteeSignUpTrackEvent(input: $input) {
    success
  }
}
    `;

/**
 * __useSendInviteeSignUpTrackEventQuery__
 *
 * To run a query within a React component, call `useSendInviteeSignUpTrackEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendInviteeSignUpTrackEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendInviteeSignUpTrackEventQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInviteeSignUpTrackEventQuery(baseOptions: Apollo.QueryHookOptions<SendInviteeSignUpTrackEventQuery, SendInviteeSignUpTrackEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendInviteeSignUpTrackEventQuery, SendInviteeSignUpTrackEventQueryVariables>(SendInviteeSignUpTrackEventDocument, options);
      }
export function useSendInviteeSignUpTrackEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendInviteeSignUpTrackEventQuery, SendInviteeSignUpTrackEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendInviteeSignUpTrackEventQuery, SendInviteeSignUpTrackEventQueryVariables>(SendInviteeSignUpTrackEventDocument, options);
        }
export type SendInviteeSignUpTrackEventQueryHookResult = ReturnType<typeof useSendInviteeSignUpTrackEventQuery>;
export type SendInviteeSignUpTrackEventLazyQueryHookResult = ReturnType<typeof useSendInviteeSignUpTrackEventLazyQuery>;
export type SendInviteeSignUpTrackEventQueryResult = Apollo.QueryResult<SendInviteeSignUpTrackEventQuery, SendInviteeSignUpTrackEventQueryVariables>;
export const GetTeamUsersDocument = gql`
    query GetTeamUsers($input: GetTeamUsersInput!) {
  getTeamUsers(input: $input) {
    teams {
      teamId
      teamName
      users {
        userId
        name
        email
        isActivated
        image
      }
    }
  }
}
    `;

/**
 * __useGetTeamUsersQuery__
 *
 * To run a query within a React component, call `useGetTeamUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTeamUsersQuery(baseOptions: Apollo.QueryHookOptions<GetTeamUsersQuery, GetTeamUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamUsersQuery, GetTeamUsersQueryVariables>(GetTeamUsersDocument, options);
      }
export function useGetTeamUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamUsersQuery, GetTeamUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamUsersQuery, GetTeamUsersQueryVariables>(GetTeamUsersDocument, options);
        }
export type GetTeamUsersQueryHookResult = ReturnType<typeof useGetTeamUsersQuery>;
export type GetTeamUsersLazyQueryHookResult = ReturnType<typeof useGetTeamUsersLazyQuery>;
export type GetTeamUsersQueryResult = Apollo.QueryResult<GetTeamUsersQuery, GetTeamUsersQueryVariables>;